module.exports = __webpack_public_path__ + "static/apca-ec0357eed10eb77ec17e992524d43a0f.png";